import { ENDPOINT_SUBSCRIPTIONS } from '../config'
import type { SubscriptionDocument } from '@/lib/types/subscription'
import type { CancelSubscriptionRequest } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Cancel subscription
 */
export async function cancelSubscription(
  request: CancelSubscriptionRequest,
): Promise<SubscriptionDocument> {
  const response = await AuthAxios.post<SubscriptionDocument>(
    `${ENDPOINT_SUBSCRIPTIONS}/cancel`,
    request
  )
  return response.data
}
